 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/Title'
 import COPYRIGHT from '@/components/Copyright'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import PART01 from '@/components/Part01'
 import CHAPTER01 from '@/components/Chapter01'
 import CHAPTER02 from '@/components/Chapter02'
 import CHAPTER03 from '@/components/Chapter03'
 import CHAPTER04 from '@/components/Chapter04'
 import CHAPTER05 from '@/components/Chapter05'
 import CHAPTER06 from '@/components/Chapter06'
 import PART02 from '@/components/Part02'
 import CHAPTER07 from '@/components/Chapter07'
 import CHAPTER071 from '@/components/Chapter071'
 import CHAPTER072 from '@/components/Chapter072'
 import CHAPTER073 from '@/components/Chapter073'
 import CHAPTER074 from '@/components/Chapter074'
 import CHAPTER075 from '@/components/Chapter075'
 import CHAPTER076 from '@/components/Chapter076'
 import CHAPTER077 from '@/components/Chapter077'
 import CHAPTER078 from '@/components/Chapter078'
 import CHAPTER079 from '@/components/Chapter079'
 import CHAPTER0710 from '@/components/Chapter0710'
 import CHAPTER0711 from '@/components/Chapter0711'
 import CHAPTER0712 from '@/components/Chapter0712'
 import CHAPTER0713 from '@/components/Chapter0713'
 import CHAPTER0714 from '@/components/Chapter0714'
 import CHAPTER0715 from '@/components/Chapter0715'
 import CHAPTER0716 from '@/components/Chapter0716'
 import CHAPTER0717 from '@/components/Chapter0717'
 import CHAPTER0718 from '@/components/Chapter0718'
 import CHAPTER0719 from '@/components/Chapter0719'
 import CHAPTER0720 from '@/components/Chapter0720'
 import CHAPTER0721 from '@/components/Chapter0721'
 import CHAPTER0722 from '@/components/Chapter0722'
 import CHAPTER0723 from '@/components/Chapter0723'
 import CHAPTER0724 from '@/components/Chapter0724'
 import CHAPTER0725 from '@/components/Chapter0725'
 import CHAPTER0726 from '@/components/Chapter0726'
 import CHAPTER0727 from '@/components/Chapter0727'
 import CHAPTER0728 from '@/components/Chapter0728'
 import CHAPTER0729 from '@/components/Chapter0729'
 import CHAPTER0730 from '@/components/Chapter0730'
 import PART03 from '@/components/Part03'
 import CHAPTER08 from '@/components/Chapter08'
 import CHAPTER081 from '@/components/Chapter081'
 import CHAPTER082 from '@/components/Chapter082'
 import CHAPTER083 from '@/components/Chapter083'
 import CHAPTER084 from '@/components/Chapter084'
 import CHAPTER085 from '@/components/Chapter085'
 import CHAPTER086 from '@/components/Chapter086'
 import CHAPTER087 from '@/components/Chapter087'
 import CHAPTER088 from '@/components/Chapter088'
 import CHAPTER089 from '@/components/Chapter089'
 import CHAPTER0810 from '@/components/Chapter0810'
 import CHAPTER0811 from '@/components/Chapter0811'
 import CHAPTER0812 from '@/components/Chapter0812'
 import CHAPTER0813 from '@/components/Chapter0813'
 import CHAPTER0814 from '@/components/Chapter0814'
 import CHAPTER0815 from '@/components/Chapter0815'
 import CHAPTER0816 from '@/components/Chapter0816'
 import CHAPTER0817 from '@/components/Chapter0817'
 import CHAPTER0818 from '@/components/Chapter0818'
 import CHAPTER0819 from '@/components/Chapter0819'
 import CHAPTER0820 from '@/components/Chapter0820'
 import CHAPTER09 from '@/components/Chapter09'
 import CHAPTER091 from '@/components/Chapter091'
 import CHAPTER092 from '@/components/Chapter092'
 import CHAPTER093 from '@/components/Chapter093'
 import CHAPTER094 from '@/components/Chapter094'
 import CHAPTER095 from '@/components/Chapter095'
 import CHAPTER096 from '@/components/Chapter096'
 import CHAPTER097 from '@/components/Chapter097'
 import CHAPTER098 from '@/components/Chapter098'
 import CHAPTER099 from '@/components/Chapter099'
 import CHAPTER10 from '@/components/Chapter10'
 import CHAPTER101 from '@/components/Chapter101'
 import CHAPTER102 from '@/components/Chapter102'
 import CHAPTER103 from '@/components/Chapter103'
 import CHAPTER104 from '@/components/Chapter104'
 import CHAPTER105 from '@/components/Chapter105'
 import CHAPTER106 from '@/components/Chapter106'
 import CHAPTER107 from '@/components/Chapter107'
 import CHAPTER108 from '@/components/Chapter108'
 import CHAPTER109 from '@/components/Chapter109'
 import CHAPTER1010 from '@/components/Chapter1010'
 import CHAPTER1011 from '@/components/Chapter1011'
 import CHAPTER1012 from '@/components/Chapter1012'
 import CHAPTER1013 from '@/components/Chapter1013'
 import CHAPTER1014 from '@/components/Chapter1014'
 import CHAPTER1015 from '@/components/Chapter1015'
 import CHAPTER11 from '@/components/Chapter11'
 import CHAPTER111 from '@/components/Chapter111'
 import CHAPTER112 from '@/components/Chapter112'
 import CHAPTER113 from '@/components/Chapter113'
 import CHAPTER114 from '@/components/Chapter114'
 import CHAPTER115 from '@/components/Chapter115'
 import CHAPTER116 from '@/components/Chapter116'
 import CHAPTER117 from '@/components/Chapter117'
 import CHAPTER118 from '@/components/Chapter118'
 import CHAPTER119 from '@/components/Chapter119'
 import CHAPTER1110 from '@/components/Chapter1110'
 import CHAPTER1111 from '@/components/Chapter1111'
 import CHAPTER1112 from '@/components/Chapter1112'
 import CHAPTER12 from '@/components/Chapter12'
 import CHAPTER121 from '@/components/Chapter121'
 import CHAPTER122 from '@/components/Chapter122'
 import CHAPTER123 from '@/components/Chapter123'
 import CHAPTER124 from '@/components/Chapter124'
 import CHAPTER125 from '@/components/Chapter125'
 import CHAPTER126 from '@/components/Chapter126'
 import CHAPTER127 from '@/components/Chapter127'
 import CHAPTER128 from '@/components/Chapter128'
 import CHAPTER129 from '@/components/Chapter129'
 import CHAPTER1210 from '@/components/Chapter1210'
 import CHAPTER1211 from '@/components/Chapter1211'
 import CHAPTER1212 from '@/components/Chapter1212'
 import CHAPTER1213 from '@/components/Chapter1213'
 import CHAPTER1214 from '@/components/Chapter1214'
 import CHAPTER1215 from '@/components/Chapter1215'
 import CHAPTER1216 from '@/components/Chapter1216'
 import CHAPTER1217 from '@/components/Chapter1217'
 import CHAPTER1218 from '@/components/Chapter1218'
 import CHAPTER1219 from '@/components/Chapter1219'
 import CHAPTER1220 from '@/components/Chapter1220'
 import CHAPTER1221 from '@/components/Chapter1221'
 import CHAPTER1222 from '@/components/Chapter1222'
 import CHAPTER1223 from '@/components/Chapter1223'
 import CHAPTER1224 from '@/components/Chapter1224'
 import CHAPTER1225 from '@/components/Chapter1225'
 import CHAPTER1226 from '@/components/Chapter1226'
 import CHAPTER1227 from '@/components/Chapter1227'
 import CHAPTER1228 from '@/components/Chapter1228'
 import CHAPTER1229 from '@/components/Chapter1229'
 import CHAPTER1230 from '@/components/Chapter1230'
 import CHAPTER13 from '@/components/Chapter13'
 import CHAPTER131 from '@/components/Chapter131'
 import CHAPTER132 from '@/components/Chapter132'
 import CHAPTER133 from '@/components/Chapter133'
 import CHAPTER134 from '@/components/Chapter134'
 import CHAPTER135 from '@/components/Chapter135'
 import CHAPTER136 from '@/components/Chapter136'
 import CHAPTER137 from '@/components/Chapter137'
 import CHAPTER138 from '@/components/Chapter138'
 import CHAPTER139 from '@/components/Chapter139'
 import CHAPTER1310 from '@/components/Chapter1310'
 import CHAPTER1311 from '@/components/Chapter1311'
 import CHAPTER1312 from '@/components/Chapter1312'
 import CHAPTER1313 from '@/components/Chapter1313'
 import CHAPTER14 from '@/components/Chapter14'
 import CHAPTER141 from '@/components/Chapter141'
 import CHAPTER142 from '@/components/Chapter142'
 import CHAPTER143 from '@/components/Chapter143'
 import CHAPTER144 from '@/components/Chapter144'
 import CHAPTER145 from '@/components/Chapter145'
 import CHAPTER146 from '@/components/Chapter146'
 import CHAPTER147 from '@/components/Chapter147'
 import CHAPTER148 from '@/components/Chapter148'
 import CHAPTER149 from '@/components/Chapter149'
 import CHAPTER1410 from '@/components/Chapter1410'
 import CHAPTER1411 from '@/components/Chapter1411'
 import CHAPTER1412 from '@/components/Chapter1412'
 import CHAPTER1413 from '@/components/Chapter1413'
 import CHAPTER1414 from '@/components/Chapter1414'
 import CHAPTER1415 from '@/components/Chapter1415'
 import CHAPTER1416 from '@/components/Chapter1416'
 import CHAPTER1417 from '@/components/Chapter1417'
 import CHAPTER1418 from '@/components/Chapter1418'
 import CHAPTER1419 from '@/components/Chapter1419'
 import CHAPTER1420 from '@/components/Chapter1420'
 import CHAPTER1421 from '@/components/Chapter1421'
 import CHAPTER1422 from '@/components/Chapter1422'
 import CHAPTER15 from '@/components/Chapter15'
 import CHAPTER151 from '@/components/Chapter151'
 import CHAPTER152 from '@/components/Chapter152'
 import CHAPTER153 from '@/components/Chapter153'
 import CHAPTER154 from '@/components/Chapter154'
 import CHAPTER155 from '@/components/Chapter155'
 import CHAPTER156 from '@/components/Chapter156'
 import CHAPTER157 from '@/components/Chapter157'
 import CHAPTER158 from '@/components/Chapter158'
 import CHAPTER159 from '@/components/Chapter159'
 import CHAPTER1510 from '@/components/Chapter1510'
 import CHAPTER1511 from '@/components/Chapter1511'
 import CHAPTER1512 from '@/components/Chapter1512'
 import CHAPTER16 from '@/components/Chapter16'
 import CHAPTER161 from '@/components/Chapter161'
 import CHAPTER162 from '@/components/Chapter162'
 import CHAPTER163 from '@/components/Chapter163'
 import CHAPTER164 from '@/components/Chapter164'
 import CHAPTER165 from '@/components/Chapter165'
 import CHAPTER166 from '@/components/Chapter166'
 import CHAPTER167 from '@/components/Chapter167'
 import CHAPTER168 from '@/components/Chapter168'
 import CHAPTER169 from '@/components/Chapter169'
 import CHAPTER1610 from '@/components/Chapter1610'
 import CHAPTER1611 from '@/components/Chapter1611'
 import CHAPTER1612 from '@/components/Chapter1612'
 import CHAPTER1613 from '@/components/Chapter1613'
 import CHAPTER1614 from '@/components/Chapter1614'
 import CHAPTER1615 from '@/components/Chapter1615'
 import CHAPTER1616 from '@/components/Chapter1616'
 import CHAPTER1617 from '@/components/Chapter1617'
 import CHAPTER1618 from '@/components/Chapter1618'
 import CHAPTER1619 from '@/components/Chapter1619'
 import CHAPTER1620 from '@/components/Chapter1620'
 import CHAPTER1621 from '@/components/Chapter1621'
 import CHAPTER1622 from '@/components/Chapter1622'
 import CHAPTER1623 from '@/components/Chapter1623'
 import CHAPTER1624 from '@/components/Chapter1624'
 import CHAPTER1625 from '@/components/Chapter1625'
 import CHAPTER1626 from '@/components/Chapter1626'
 import LOVE_2 from '@/components/love_2'
 import INDEX from '@/components/Index'
 import ACKNOWLEDGMENTS from '@/components/Acknowledgments'
 import AUTHOR from '@/components/Author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Part01",
 			"name" : "Part01",
 			"component" : PART01
 		},
 		{
 			"path" : "/Chapter01",
 			"name" : "Chapter01",
 			"component" : CHAPTER01
 		},
 		{
 			"path" : "/Chapter02",
 			"name" : "Chapter02",
 			"component" : CHAPTER02
 		},
 		{
 			"path" : "/Chapter03",
 			"name" : "Chapter03",
 			"component" : CHAPTER03
 		},
 		{
 			"path" : "/Chapter04",
 			"name" : "Chapter04",
 			"component" : CHAPTER04
 		},
 		{
 			"path" : "/Chapter05",
 			"name" : "Chapter05",
 			"component" : CHAPTER05
 		},
 		{
 			"path" : "/Chapter06",
 			"name" : "Chapter06",
 			"component" : CHAPTER06
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js